layoutHandler = {
    $panelLayoutSidebar = $('.panel-layout-sidebar'), 
    $sideNavContainer = $('.slider-active'),
    $triggerOpenSideNav = $('.trigger-bars'),
    $triggerCloseSidePanel = $('.trigger-close-side-panel'),
    $titleNavigationSidebar = $('.panel-title-navigation-sidebar'),
    $sidebarContainer = $('.content-side-container'),
    
    init = function(){
        var self = this;
        window.onscroll = function (e) {
            var doc = document.documentElement;
            var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
            
            if (self.$sideNavContainer) {
                if (top < 10) {
                    self.$triggerOpenSideNav.click();
                } else if (!self.$sideNavContainer.find('.side-nav').hasClass('minimized')) {
                    self.$triggerCloseSidePanel.click();
                }
            }
        }

        $(window).on("resize", function() {
            // make sure sidebar height is consistent relative to window height
            self.$sidebarContainer.css('height', 'calc(100vh - '+$('header').outerHeight()+'px)')
        }).trigger("resize");

        this.$triggerCloseSidePanel.on('click', function(){
            self.$sideNavContainer.find('.side-nav').addClass('minimized');
            self.$sideNavContainer.find('.bars-container').removeClass('hide');
        });

        this.$triggerOpenSideNav.on('click',  function(){
            self.$sideNavContainer.find('.side-nav').removeClass('minimized');
            self.$sideNavContainer.find('.bars-container').addClass('hide');
        });

        // automatically add internal navigation for each title in main panel
        if (this.$titleNavigationSidebar.length > 0) {
            // for the time being, use h1 only
            $('.layout-content-container h1').each(function() {
                var anchorId = $(this).text().toLowerCase().replace(' ', '-');
                $(this).attr('id', anchorId);
                $('<div class="h2-style text-uppercase sidebar-item-margin"><a href="#'+anchorId+'" aria-label="Navigate to '+$(this).text()+'">'+$(this).text()+'</a></div>')
                    .appendTo(self.$titleNavigationSidebar);
            });
            this.$titleNavigationSidebar.find('a').on("click", function(e) {
                e.preventDefault();
                var $headingTarget = $('.layout-content-container h1'+$(this).attr('href'));
                $('html, body').animate({
                    scrollTop: $headingTarget.offset().top - $('header').outerHeight() - 32
                }, '250ms');
            });
        }
    }
}